<div [style.padding]="'30px'" [style.display]="'flex'" class="progress-loader" [style.flex-direction]="'column'" [style.align-items]="'center'">
    <h3 *ngIf="showFinishedMessage" class="loading_text">{{locale.translate("please_wait_while_uploding_scorm_package")}}</h3>
    <h3 *ngIf="!showFinishedMessage && !uploadFailed" class="loading_text">{{locale.translate("please_wait_while_uploding_scorm_package")}}</h3>
    
    <h3 *ngIf="!showFinishedMessage && uploadFailed" class="loading_text">{{locale.translate("internet_down")}}</h3>

    <!-- <div [style.height]="'8px'" [style.width]="'300px'" [style.border-radius]="'10px'"
        [style.background-color]="'lightgrey'"
        [style.box-shadow]="'inset -5px -5px 10 -15px rgba(0,0,0,.3), inset 5px -5px 10px -15px rgba(0,0,0,.5)'"
        [style.overflow]="'hidden'">
        <div [style.height]="'8px'" [style.width.%]="progress > 100 ? 100 : progress"
            [style.background-color]="showFinishedMessage ? '#40b630' : uploadFailed ? 'lightgray' : '#0091EA'"
            [style.transition]="'width 0.2s ease-in, background-color 0.2s ease-in'" [style.border-radius]="'10px'"
            [style.box-shadow]="'15px 14px 40px -14px rgba(201,201,201,1)'" [style.position]="'relative'">
            <p *ngIf="progress > 10" [style.color]="'white'" [style.font-weight]="600" [style.font-size]="'8px'"
                [style.position]="'absolute'" [style.right]="'5px'" [style.top]="'50%'"
                [style.transform]="'translateY(-50%)'">
                {{ progress > 100 ? 100 : progress }}%
            </p>
        </div>
    </div> -->

    <div class="progress-width">
        <mat-progress-bar  mode="buffer" [value]="progress" class="horizontal-progress-bar">
        </mat-progress-bar>
        <p  class="entity-title">
            {{ progress > 100 ? 100 : progress }}%
        </p>
    </div>

    <ng-container *ngIf="uploadFailed">
        <div fxLayout="row" fxLayoutAlign="center start" fxLayoutGap="30px">
            <button class="retry-buttton" type="button" mat-raised-button (click)="resumeUpload()">{{locale.translate('try_again')}}</button>
            <button class="retry-buttton" type="button" mat-raised-button (click)="cancel()">{{locale.translate('cancel')}}</button>
        </div>
       

    </ng-container>
</div>